module.exports = __webpack_public_path__ + "img/admin_adv_13.c9055871.png";